import { render, staticRenderFns } from "./EditStudentForm.vue?vue&type=template&id=5ea0ed0f"
import script from "./EditStudentForm.vue?vue&type=script&lang=js"
export * from "./EditStudentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports